import React, { ReactElement } from 'react';

import SheetContainer, { Content, Header, Heading, Overlay, Sheet } from '../../../../../../mobile/structural/sheet';
import { UseSheetReturnType } from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { Button, FormText } from '@milanote/roma';

type LabelDeleteSheetProps = {
    onDelete: () => void;
    sheetProps: UseSheetReturnType;
};

const LabelDeleteSheet = ({ onDelete, sheetProps }: LabelDeleteSheetProps): ReactElement => {
    const translate = useTranslator('popup', 'labels.edit');

    return (
        <SheetContainer className="LabelDeleteSheet" {...sheetProps}>
            <Overlay />
            <Sheet>
                <Header>
                    <Heading>{translate('deleteTitle')}</Heading>
                </Header>
                <Content className="px-3xl pt-lg">
                    <div className="flex flex-col gap-3xl">
                        <FormText align="center" size="lg" color="secondary">
                            {translate('deleteDescription')}
                        </FormText>

                        <div className="pb-6xl flex gap-lg">
                            <Button
                                color="secondary"
                                size="xl"
                                className="flex-1"
                                onClick={() => sheetProps.dispatchCloseSheet()}
                            >
                                {translate('deleteCancel')}
                            </Button>
                            <Button color="primary-destructive" size="xl" className="flex-1" onClick={onDelete}>
                                {translate('deleteConfirm')}
                            </Button>
                        </div>
                    </div>
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default LabelDeleteSheet;
